import type { StateCreator } from 'zustand';
import type { RoadmapItem, FunnelData } from '../types';
import { roadmapApi, funnelApi } from '../services/roadmapApi';

export interface RoadmapSlice {
  roadmapItems: RoadmapItem[];
  roadmapLoading: boolean;
  funnelData: FunnelData | null;
  funnelLoading: boolean;
  fetchRoadmap: (params?: { phase?: string; status?: string; market?: string; category?: string }) => Promise<void>;
  updateRoadmapItem: (id: number, data: Partial<RoadmapItem>) => Promise<void>;
  seedRoadmap: () => Promise<void>;
  fetchFunnel: (market?: string) => Promise<void>;
}

export const createRoadmapSlice: StateCreator<RoadmapSlice> = (set, get) => ({
  roadmapItems: [],
  roadmapLoading: false,
  funnelData: null,
  funnelLoading: false,

  fetchRoadmap: async (params) => {
    set({ roadmapLoading: true });
    try {
      const items = await roadmapApi.list(params);
      set({ roadmapItems: items, roadmapLoading: false });
    } catch {
      set({ roadmapLoading: false });
    }
  },

  updateRoadmapItem: async (id, data) => {
    const updated = await roadmapApi.update(id, data);
    set((s) => ({
      roadmapItems: s.roadmapItems.map((item) => (item.id === id ? updated : item)),
    }));
  },

  seedRoadmap: async () => {
    await roadmapApi.seed();
    await get().fetchRoadmap();
  },

  fetchFunnel: async (market) => {
    set({ funnelLoading: true });
    try {
      const data = await funnelApi.get(market);
      set({ funnelData: data, funnelLoading: false });
    } catch {
      set({ funnelLoading: false });
    }
  },
});
